import React, { FunctionComponent } from 'react';
import InlineMessaging, {
  InlineMessagingTheme,
} from '@havenengineering/module-shared-library/dist/components/InlineMessaging/InlineMessaging';
import { Button } from '@havenengineering/module-shared-owners-ui/dist/components/Button';

type Props = {
  state: Record<string, any>;
  handleReturnToDashboard: () => void;
  handleSubmit: () => Promise<void>;
  isLoading: boolean;
  isError: boolean;
};

export const SummaryRequest: FunctionComponent<Props> = ({
  state,
  handleReturnToDashboard,
  handleSubmit,
  isLoading,
  isError,
}) => {
  return (
    <div>
      <p className="owners-body">
        Your are requesting:
        <strong>{` £${state.amount || 0}`}</strong>
      </p>
      <hr />
      <p className="owners-body">
        To apply for a refund, you must also have a credit balance on your owner
        account that is over £100 after Covid credit have been applied. If your
        refund is approved, it will be transferred directly to your bank account
        28 days after your application has been approved.
      </p>
      {isError && (
        <InlineMessaging
          type={InlineMessagingTheme.ERROR_THEME}
          title="Error"
          message="Something went wrong, please try again"
          dismissible={false}
        />
      )}
      <Button fullWidth onClick={() => handleSubmit()} isLoading={isLoading}>
        Continue to submit your request
      </Button>
      <p className="owners-body">
        When you submit this form we will process your data to enable us to
        manage your request and respond to you. We may also keep a record of
        this communication for an appropriate period of time to assist us when
        managing future communication and to demonstrate how we communicated
        with you. We do this based on our contractual obligations to our owners,
        our legal obligations and our legitimate interests. Please see our
        <a href="https://www.owner-services.co.uk/support/privacy-policy">
          &nbsp;full privacy policy&nbsp;
        </a>
        for more information on how we process your personal data.
      </p>
      <Button fullWidth variant="outlined" onClick={handleReturnToDashboard}>
        Return To Dashboard
      </Button>
    </div>
  );
};
